<template>
    <!--검사 상태-->
    <div class="box-container">
        <div class="box-container-header">
            <h2 :key="locale" class="box-title">
                {{ $t('DASHBOARD.TITLE.STATE') }}<!--검사 상태-->
                <select-box-single select-id="select_state_type"
                    select-class="type-inline size-s"
                    :select-box-options="typeOptions"
                    :select-box-value="chartType"
                    :use-translate="true"
                    @onSelectChange="changeChartType($event.value)"></select-box-single>
                <button type="button"
                    class="buttons-icon"
                    data-type="ghost"
                    data-size="xs"
                    data-icon="info"
                    data-trigger="tooltip"
                    data-tooltip-content="#tooltip-compliance-status">info</button>
            </h2>

            <!-- 검사 상태 툴팁 -->
            <div class="tooltip_templates">
                <div id="tooltip-compliance-status">
                    {{ $t('DASHBOARD.STATE.TOOLTIP_1') }}<br>
                    {{ $t('DASHBOARD.STATE.TOOLTIP_2') }}
                </div>
            </div>

            <div class="actions">
                <div class="segmented-control">
                    <input type="radio" id="sc02" name="sc"
                           @change="activeFailStat = 'F'; getDataByVendor();" :checked="activeFailStat === 'F' ? true : null">
                    <label for="sc02">{{ $t('DASHBOARD.SUMMARY.TAB.FAIL') }}<!--실패한 규칙--></label>
                    <input type="radio" id="sc01" name="sc"
                           @change="activeFailStat = 'P'; getDataByVendor();" :checked="activeFailStat === 'P' ? true : null ">
                    <label for="sc01">{{ $t('DASHBOARD.SUMMARY.TAB.PASS') }}<!--패스한 규칙--></label>
                    <input type="radio" id="sc03" name="sc"
                           @change="activeFailStat = 'E'; getDataByVendor();" :checked="activeFailStat === 'E' ? true : null">
                    <label for="sc03">{{ $t('DASHBOARD.SUMMARY.TAB.ERROR') }}</label>
                </div>

                <dashboard-widget v-bind:type="'state'"></dashboard-widget>
            </div>
        </div>
        <nav class="navigation-tab" data-size="s">
            <h2 class="title">Product TAB</h2>
            <button v-for="(item) in inUseVendors" :key="item.CLOUD_VNDR_ID"
                type="button"
                class="tab-item"
                :name="item.CLOUD_VNDR_ID"
                :class="[item.CLOUD_VNDR_ID === selectedVendor ? 'selected' : null ]"
                @click="selectVendor(item.CLOUD_VNDR_ID)"
            >
                {{ Common.getShortName(item.CLOUD_VNDR_ID) }}
            </button>
            <button type="button"
                    class="tab-item"
                    :name="VENDOR.OTHER"
                    :class="[VENDOR.OTHER===selectedVendor ? 'selected' : '' ]"
                    @click="selectVendor(VENDOR.OTHER)">
                {{ $t('TYPE.OTHERS') }}<!--기타-->
            </button>
        </nav>
        <PieChart
            :locale="locale"
            :chartData="filterDataByVendor"
            :activeFailStat="activeFailStat"
            :pending="pending"
            :chartType="chartType"
        />
        <div-loading v-if="pending"></div-loading>
    </div>
</template>


<script>
import DashboardWidget from "./dashboardWidget.vue";
import PieChart from "./reports/PieChart.vue";
import _ from "lodash";

export default {
    name: 'DashboardState',
    components: {
        DashboardWidget,
        PieChart
    },
    props: {
        filterData: Object,
        accountList: Array,
        selectedAccounts: Array,
        curCmpnId:String,
        locale: String,
        failedRulesList: Array,
        pending: Boolean,
        inUseVendors: Array,
    },
    data() {
        return {
            disabledOTHER: true,
            disableAZURE : true,
            disableAWS: true,
            disableGCP: true,
            filterDataByVendor: [],
            activeFailStat: 'F',
            chartType: "prodList", // prodList, ctgList 로 나뉨. prodList 가 기본 값
            typeOptions: this.constants.CHART_TYPE_OPTIONS,
            VENDOR: this.constants.VENDOR,
            selectedVendor: "",
        }
    },
    watch: {
        failedRulesList() {
            this.getDataByVendor();
        },
        locale() {
            this.getDataByVendor();
        },
        inUseVendors(value) {
            if (value.length > 0) {
                this.selectedVendor = value[0].CLOUD_VNDR_ID;
            }
        }
    },
    methods: {
        selectVendor(id) {
            this.selectedVendor = id;
            this.getDataByVendor();
        },
        getDataByVendor() { // create chart
            let dataByVendor = [];
            let self = this;
            let data = this.failedRulesList;

            // account filter 적용
            if (this.filterData != null && this.filterData.acnt != null && typeof (this.filterData.acnt) !== 'undefined' && this.filterData.acnt.length > 0) {
                data = _.filter(data, function (o) {
                    let isInclude = false;
                    for (let acnt of self.filterData.acnt) {
                        isInclude = _.includes(o.acnt, acnt)
                        if (isInclude) break;
                    }
                    return isInclude;
                });
            }
            if (this.selectedVendor === this.VENDOR.AWS) {
                dataByVendor = data.filter(function (rule) {
                    return rule.vendors === "AWS"
                });
            } else if (this.selectedVendor === this.VENDOR.AZURE) {
                dataByVendor = data.filter(function (rule) {
                    return rule.vendors === "AZU"
                });
            } else if (this.selectedVendor === this.VENDOR.GCP) {
                dataByVendor = data.filter(function (rule) {
                    return rule.vendors === "GCP"
                });
            } else if (this.selectedVendor === this.VENDOR.OTHER) {
                dataByVendor = data.filter(function (rule) {
                    return rule.vendors === "Others"
                });
            }
            this.filterDataByVendor = dataByVendor;
        },
        // 프로덕트 / 카테고리 변경
        changeChartType(type) {
            if (this.chartType !== type) {
                this.chartType = type;
                this.getDataByVendor();
            }
        }
    }
}
</script>

<style>
@import '../../../static/styles/gv_amchart.css';
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dashboardState.vue